<template>
  <section>
    <area-list
      :query="query"
      :selected.sync="selectedItem"
      :loadingItem="loadingItem"
      @select="onSelected"
    />

    <hr />

    <section id="item" style="min-height: 600px;">
      <area-home
        v-if="selectedItem"
        :code="selectedItem.code"
        :loading.sync="loadingItem"
        @updated="onUpdated"
      />
    </section>

    <b-loading :active="isLoading" :is-full-page="true" :can-cancel="false" />
  </section>
</template>

<script>
import AreaList from '@/components/areas/AreaList'
import AreaHome from '@/components/areas/AreaHome'

export default {
  name: 'AreaHomePage',
  components: {
    AreaList,
    AreaHome
  },

  data() {
    const { query } = this.$route

    return {
      query: query,
      loadingItem: false,
      selectedItem: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  },
  computed: {
    isLoading() {
      return this.loadingItem
    }
  },
  methods: {
    onUpdated(item) {
      this.selectedItem = item
    },
    onSelected() {
      this.$scrollTo(`#item`, { offset: -60 })
    }
  }
}
</script>
